import { useState } from "react";

import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import {
  DialogActions,
  DialogContent,
  IconButton,
  TextField,
} from "@mui/material";

import "../anular/dialogApprove.css";
import { Model } from "../../../models/model";

export const DialogNewTemplates = ({ open, setOpen, detailBudget }) => {
  const [msgError, setMsgError] = useState("");

  const [form, setForm] = useState({
    nombre: `plantilla ${detailBudget.referencia}`,
  });

  const handleSave = async () => {
    if (form.nombre === "") {
      setMsgError("Falta ingresar nombre");
      return false;
    }

    const dataForm = {
      nombre: form.nombre,
      id_ppto_origen: detailBudget.id,
      detalle_plantilla: detailBudget,
    };

    const result = await Model.save({
      url: "templates",
      dataForm: dataForm,
      resultData: true,
    });

    console.log("--result save--", result);
    setOpen(false);
  };

  const handleChange = ({ target }) => {
    setForm({
      ...form,
      nombre: target.value,
    });
  };

  return (
    <Dialog
      onClose={() => setOpen(false)}
      open={open}
      className="p-dialog-approve"
    >
      <DialogTitle className="ColorTitleDocument" id="scroll-dialog-title">
        <IconButton
          aria-label="close"
          style={{ padding: "0", float: "right" }}
          onClick={() => setOpen(false)}
        >
          <CloseIcon style={{ color: "#78667E" }} />
        </IconButton>
      </DialogTitle>
      <DialogContent className="content">
        <div className="d-flex justify-content-center p-icons align-items-center">
          <i
            className="bi bi-file-earmark-ruled"
            style={{ fontSize: "50px", color: "#909090" }}
          ></i>
          <i
            className="bi bi-arrow-right ms-2 me-2"
            style={{ fontSize: "30px", color: "#909090" }}
          ></i>
          <i
            className="bi bi-file-earmark-ruled"
            style={{ fontSize: "50px", color: "#909090" }}
          ></i>
        </div>

        <div className="text">
          <h3>Guardar como plantilla</h3>
        </div>

        <div className="p-text-comments mt-4">
          <TextField
            label="Nombre de la plantilla"
            name="referencia"
            id="outlined-size-small"
            value={form.nombre || ""}
            size="small"
            fullWidth
            placeholder="Ingrese nombre de la plantilla"
            onChange={handleChange}
          />
        </div>

        {msgError !== "" && (
          <p
            style={{
              color: "red",
              textAlign: "center",
              fontSize: "14px",
              marginTop: "5px",
            }}
          >
            {msgError}
          </p>
        )}
      </DialogContent>
      <DialogActions className="d-flex justify-content-center mt-3 mb-2 p-actions">
        <button className="approve" onClick={handleSave}>
          Guardar
        </button>
      </DialogActions>
    </Dialog>
  );
};
